<section class="review-page-section">
    <div class="container-xl" *ngIf="reviewViewData">
        <div class="row justify-content-center">
            <div class="col-md-10">
                <div class="review-wrapper">

                    <header class="review-header text-center mb-5">
                        <h1 class="review-title">{{reviewViewData.review_title}}</h1>
                    </header>

                    <div class="review-main-content-card card shadow-sm mb-5">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4 mb-4 mb-md-0">
                                    <div class="image-wrapper position-relative">
                                        <img [src]="shared.getImageURL(reviewViewData.review_image)" class="review-image br-15 img-fluid shadow-sm">
                                    </div>
                                </div>
                                
                                <div class="col-md-8">
                                    <p class="review-text" [innerHTML]="reviewViewData.review"></p>
                                    
                                    <h4 class="ratings-heading mt-4 mb-3">User's Ratings</h4>
                                    <div class="row">
                                        <div *ngFor="let rating of ratingFieldsList" class="col-lg-6 col-md-12 col-sm-6 mt-2">
                                            <div class="rating-item p-2 border-bottom">
                                                <h6 class="rating-label-text">
                                                    <strong>{{ rating.label2 }}</strong>
                                                </h6>
                                                <div class="rating-stars-container">
                                                    <ng-container *ngFor="let star of getStars(rating.value)">
                                                        <i class="fas fa-star filled-star me-1"></i>
                                                    </ng-container>
                                                    <ng-container *ngFor="let star of getStars(5 - rating.value)">
                                                        <i class="far fa-star empty-star me-1"></i>
                                                    </ng-container>
                                                    <span class="rating-value">({{ rating.value }}/5)</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="direkt-parameters-card card shadow-sm mb-5">
                        <div class="card-header">
                            <h5 class="card-title-main">Direkt Property Parameters</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <ng-container *ngFor="let star of ratingFieldsTemplate; let i = index">
                                    <div class="col-lg-4 col-md-6 col-sm-12 mb-4">
                                        <div class="parameter-box p-3 border rounded">
                                            <div class="parameter-label bold">{{i+1}}. {{star.label}}</div>
                                            <div class="parameter-rating-display mt-2">
                                                <ng-container *ngFor="let ar of allRating">
                                                    <ng-container *ngFor="let star of getStars(ar)">
                                                        <i class="fas fa-star filled-star-small me-1"></i>
                                                    </ng-container>
                                                    <div class="parameter-description mt-1">
                                                        {{reviews[star.field] && reviews[star.field][ar] ? reviews[star.field][ar] : ""}}
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="existing-reviews-card card shadow-sm mb-5">
                        <div class="card-header">
                            <h5 class="card-title-main">User Reviews</h5>
                        </div>
                        <div class="card-body">
                            <div *ngFor="let review of reviewViewData" class="media review-item mb-4 pb-3 border-bottom">
                                <div class="media-body">
                                    <h5 class="review-username mt-0">{{ review.username }}</h5>
                                    <p class="review-quote"><em>“{{ review.review }}”</em></p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="add-review-card card shadow-lg mb-5">
                        <div class="card-header card-header-action">
                            <h5 class="card-title-main">Add Your Review</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 mb-3">
                                    <textarea class="form-control review-textarea" [(ngModel)]="reviewContent" rows="5" placeholder="Share your thoughts and experiences about this property here..."></textarea>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-12 text-left">
                                    <button (click)="addReview()" class="btn btn-theme review-submit-btn">
                                        <i class="fas fa-paper-plane me-2"></i> Submit Review
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>